<template>
  <div>
    <filter-component />
    <table-component />
  </div>
</template>

<script>
  import FilterComponent from '@autocaller_v2/components/products-filter.vue';
  import TableComponent from '@autocaller_v2/components/products-table.vue';

  export default {
    components: { FilterComponent, TableComponent }
  };
</script>
